import { RootState } from '@app/model';

export const selectIsCoverLoading = (state: RootState) => state.bookEdit.isPhotoLoading;
export const selectCoverError = (state: RootState) => state.bookEdit.coverError;
